import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';

// This sets the mock adapter on the default instance
const ApiMock = new MockAdapter(axios, { delayResponse: 100 });

export default ApiMock


// WEBPACK FOOTER //
// ./src/sources/mocks/ApiMock.js